import { BusEvent } from '@web/common';

export class AdminCosmeticCreatedBusEvent extends BusEvent {}
